module.exports = __webpack_public_path__ + "static/ioof-logo-247d242e2a9ab4a4970c205ff7047cff.png";